<template>
  <div class="newsTabs" :class="{ oneTabs: tabsData.length === 1 }">
    <div class="name" v-if="tabsData.length > 1 && tTitle">{{ tTitle }}</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane
        v-for="(item, key) in tabsData"
        :key="key"
        :name="JSON.stringify(key)"
        :disabled="tabsData.length === 1"
        :label="item.colValue"
      >
        <div class="newsList">
          <template v-for="(tItem, tkey) in item.newsList">
            <div class="item" :class="{ isHot: tItem.isHot && tItem.isHot!=='0' }" @click="openLink(tItem.id)" :key="tkey">
              <span>
                {{ tItem.title }}
              </span>
              <em>{{ tItem.publishTime?tItem.publishTime:tItem.createTime }}</em>
            </div>
          </template>
          <img src="@img/empty.png" v-if="!item.newsList || item.newsList.length === 0" alt="" class="empty" />
        </div>
        <div class="list-page" v-if="item.newsList && item.newsList.length > 0">
          <el-pagination
            layout="prev, pager,sizes, next"
            :key="key"
            :current-page="item.page.current"
            :page-size="item.page.size"
            @size-change="handleSizeChange"
            @current-change="currentChange"
            :total="item.page.total"
          >
          </el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'NewsListTabs',
  props: {
    tabsData: {
      type: Array,
      required: true
    },
    tTitle: {
      type: String,
      required: false,
      default: ''
    },
    active: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      activeName: '0'
    };
  },
  components: {},
  watch: {},
  mounted() {
    this.activeName = this.active.toString();
  },
  methods: {
    handleClick() {
      this.$emit('changeActive', this.activeName);
    },
    openLink(id) {
      let routeData = this.$router.resolve({
        name: 'Detail',
        params: { id: id }
      });
      window.open(routeData.href, '_blank');
    },
    currentChange(val) {
      this.$emit('currentChange', val);
    },
    handleSizeChange(val) {
      this.$emit('handleSizeChange', val);
    }
  }
};
</script>

<style lang="less" scoped>
.newsTabs {
  position: relative;
  padding: 0 18px;
  margin-bottom: 18px;
  min-height: 290px;
  .name {
    position: absolute;
    left: 18px;
    top: 0;
    font-size: 18px;
    color: #000;
    font-weight: 600;
    line-height: 40px;
    width: 105px;
    padding-left: 18px;
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: #013f99;
      z-index: 1;
    }
  }
  /deep/.el-tabs {
    .el-tabs__header {
      padding-left: 105px;
      padding-top: 10px;
      margin-bottom: 20px;
    }
    .el-tabs__item {
      font-size: 16px;
      color: #000;
      font-weight: normal;
      height: 30px;
      line-height: 30px;
      padding: 0 13px !important;
      box-sizing: border-box;
    }
    .el-tabs__item.is-active {
      color: #000;
    }
    .el-tabs__active-bar {
      height: 4px;
      background-color: #013f99;
      left: -13px;
      right: -13px;
      padding: 0 13px;
      box-sizing: content-box;
    }
    .el-tabs__nav-wrap::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 2px;
      background-color: #013f99;
      z-index: 1;
    }
    .el-tab-pane {
      padding-right: 10px;
      padding: 0 86px;
      &.tPl {
        padding-left: 10px;
      }
    }
  }
  &.oneTabs {
    .name {
      display: none;
    }
    /deep/.el-tabs {
      .el-tabs__header {
        padding: 0;
      }
      .el-tabs__active-bar {
        left: 0;
        right: 0;
        padding: 0;
        box-sizing: content-box;
      }
      .el-tabs__item {
        font-weight: 600;
        height: 35px;
        padding: 0 !important;
      }
    }
  }
  .item {
    position: relative;
    padding-right: 120px;
    padding-left: 16px;
    line-height: 30px;
    font-size: 14px;
    color: #5e5a5a;
    cursor: pointer;
    border-bottom: 1px solid #e0e0e0;
    &.isHot {
      padding-left: 52px !important;
      background-position: 16px center;
    }
    &:last-child {
      border-bottom: 0;
    }
    &::before {
      position: absolute;
      content: '';
      left: 0;
      top: 50%;
      width: 8px;
      height: 8px;
      margin-top: -4px;
      background: #000000;
    }
    &:hover {
      color: #999;
    }
    span {
      display: block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    em {
      position: absolute;
      top: 0;
      right: 0;
    }
  }
  .firstItem {
    border-bottom: 1px solid #c3c3c3;
    padding-bottom: 10px;
    margin-bottom: 8px;
    cursor: pointer;
    &:hover {
      opacity: 0.9;
    }
    h3 {
      position: relative;
      font-size: 16px;
      color: #013f99;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 120px;
      line-height: 23px;
      margin-bottom: 4px;
      span {
        position: absolute;
        top: 0;
        right: 0;
        font-size: 14px;
        color: #5e5a5a;
      }
    }
    p {
      line-height: 23px;
      font-size: 14px;
      color: #5e5a5a;
      line-height: 23px;
      height: 46px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      padding: 0 10px;
    }
  }
  .newsList {
    position: relative;
    min-height: 309px;
    .empty {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: auto;
      height: auto;
      margin: auto;
    }
  }
  /* .list-page {
    padding: 10px 0 10px 0;
    /deep/.el-pager li {
      position: relative;
      overflow: hidden;
      padding: 0 8px;
      min-width: 10px;
      &:before {
        position: absolute;
        content: '[';
        left: 2px;
        top: 50%;
        line-height: 26px;
        margin-top: -14px;
      }
      &:after {
        position: absolute;
        content: ']';
        right: 2px;
        top: 50%;
        line-height: 26px;
        margin-top: -14px;
      }
    }
  } */
}
</style>
